/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';
import { I18nService } from '@dm/core';

@Component({
    selector: 'app-monopolize-search',
    templateUrl: './monopolize-search.component.html',
    styleUrls: ['./monopolize-search.component.scss'],
})
export class MonopolizeSearchComponent {
    noResultTip = this.i18n.get('home.search_term_noResult_lab');

    constructor(public i18n: I18nService) {
    }

    formatNum = (num: string | number): string => this.i18n.get('home.search_term_total_lab', [num]);
    formatNumInaccurate = (num: string | number): string => this.i18n.get('home.search_term_more_lab', [num]);
}
